module.exports = __webpack_public_path__ + "static/scale-model-of-pedal-pub-twin-cities-in-minneapolis-minnesota-e74285bc6d219b1d99576501083a9729.png";